import React from "react";

const ErrorPage = () => {
  return (
    <div
      className={`h-100 w-100 d-flex justify-content-center align-items-center`}
    >
      {/* Put a nice graphic here */}
      Woops. Something went wrong.
    </div>
  );
};

export default ErrorPage;
